<app-title
  title="Appointments"
  description="View and manage your appointments below"
  linktext="Book"
  (linkclick)="book()"
></app-title>
@if (appointments$ | async; as appointments) {
  @if (appointments | isClientErrorMessage) {
    <app-error [error]="appointments" (retry)="load()"></app-error>
  } @else {
    <div class="mt-2">
      <app-horizontalpills [config]="getPillsConfig()" (itemclick)="pillClicked($event)"></app-horizontalpills>
    </div>
    <app-stackedlist [config]="(config$ | async) || { items: [] }"></app-stackedlist>
  }
} @else {
  <app-loader></app-loader>
}
